export default __webpack_public_path__ + "static/media/015-gloves.b424dd6f.svg";